<template>
  <div class="map">
    <el-card style="width: 900px; margin-bottom: 20px;">
      <el-input v-model="data.keyWord" placeholder="输入地址关键字，搜索点位" style="width: calc(100% - 100px);" />
      <el-button @click="search" type="primary" style="margin-left: 20px; width: 80px;">搜索</el-button>
      <template v-if="data.placeList.length > 0">
        <div style="height: 20px;"></div>
        <el-table :data="data.placeList" style="width: 100%;" height="200" :show-header="false" size="small">
          <el-table-column prop="name" width="300" show-overflow-tooltip />
          <el-table-column prop="formattedAddress" show-overflow-tooltip />
          <el-table-column width="80" aline="center" show-overflow-tooltip>
            <template #default="scope">
              <el-link @click="handleClick(scope.row)" type="primary" size="small">使用</el-link>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>
    <div id="map" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import math from '../../utils/math'
import api from '../../apis/api'
import * as echarts from 'echarts'
import util from '../../utils/util'
import { Loader } from '@googlemaps/js-api-loader'

const mapLoader = new Loader({
  apiKey: 'AIzaSyBi5KgsssFebf3i05F_llpS8poRAnHXXpU',
  libraries: ['places'],
});

const data = reactive({
  keyWord: '',
  placeList: [],
})

const search = () => {
  const params = {
    keyWord: data.keyWord
  }
  api.get('/backend/map/byKeyword', { params }).then(res => {
    if (res.list.length === 0) {
      ElMessage.error('没查询到位置')
    }
    data.placeList = res.list
  })
}

const handleClick = (row) => {
  console.log(row)
  // 地图移动到中点为latLng
  data.map.setCenter({ lat: row.lat, lng: row.lng })
  data.map.setZoom(18)
}

onMounted(() => {
  mapLoader.importLibrary('maps').then(mapsLoader => {
    // 初始化MAP
    data.map = new mapsLoader.Map(document.getElementById('map'), {
      center: { lat: 43.70, lng: -79.4 },
      zoom: 11,
      mapId: 'b0129775b4e1462ad56c1bf4',
    })

    // 增加点击事件
    data.map.addListener('click', (event) => {
      const clickedLatLng = event.latLng
      // 标点
      mapLoader.importLibrary('marker').then((markerLoader) => {
        console.log('Marker library loaded')
        new markerLoader.AdvancedMarkerElement({
          map: data.map,
          position: clickedLatLng,
        })
      })
    })
  })
})
</script>

<style lang="less"></style>